
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ramadan-activities",
      function () {
        return require("private-next-pages/ramadan-activities/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ramadan-activities"])
      });
    }
  